import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetGear: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 15a3 3 0 100-6 3 3 0 000 6zm7.94-1l-1.2-.69a6 6 0 000-2.62l1.2-.69a.5.5 0 00.18-.68l-1-1.73a.5.5 0 00-.68-.18l-1.2.69a6 6 0 00-2.27-1.31V5.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v1.38A6 6 0 009.7 8.2l-1.2-.69a.5.5 0 00-.68.18l-1 1.73a.5.5 0 00.18.68l1.2.69a6 6 0 000 2.62l-1.2.69a.5.5 0 00-.18.68l1 1.73a.5.5 0 00.68.18l1.2-.69a6 6 0 002.27 1.31v1.38a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-1.38a6 6 0 002.27-1.31l1.2.69a.5.5 0 00.68-.18l1-1.73a.5.5 0 00-.18-.68z" />
      </svg>
    </div>
  );
};

export default WidgetGear;
